import axios from "axios";
import { LOGIN, ADD_NEW_DATA } from "../Endpoints/endpoint";

const API = axios.create({ baseURL: process.env.REACT_APP_API_PATH });

export const Login = (formData) => API.post(LOGIN, formData);
export const AddForm = (newValue) => API.post(ADD_NEW_DATA, newValue);